<template>
  <v-dialog v-model="dialog" persistent max-width="800">
    <v-card>
      <v-card-title>แบบฟอร์มขอกำหนดตำแหน่งทางวิชาการ</v-card-title>
      <v-card-text>
        <v-radio-group v-model="form.academic_type_id" row>
          <v-radio v-for="type in academic_types" :key="type.id" :label="type.name" :value="type.id"></v-radio>
        </v-radio-group>
        <v-row>
          <v-col cols="12" md="6">
            <v-text-field v-model="form.program_name" solo dense label="สาขาวิชา"></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field v-model="form.program_code" solo dense label="รหัสสาขาวิชา"></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn color="success" @click="submit">บันทึก</v-btn>
        <v-btn color="error" @click="close_dialog">ปิด</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: [
    'dialog',
    'form'
  ],
  computed: {
    academic_types() { return this.$store.state.academic.academic_types }
  },
  methods: {
    submit() {
      this.$emit('submit', this.form);
    },
    close_dialog() {
      this.$emit('update:dialog', false);
    }
  }
}
</script>